<script lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import commonMixin from '@/plans/CONCURRENCY_MEETING_BASIC/mixin';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
// import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';

export default {
  mixins: [mixin, commonMixin],
  name: 'ConcurrentMeetingCart',
  computed: {
    showRemove() {
      const fromPlanType = getPlanTypeByCategory(pageConfig.plan);
      return fromPlanType !== this.planType;
    },
  },
  methods: {
    // mx_license(num) {
    //   return (
    //     <div class="opc-cart-item__text">
    //       {num} {getPlanUnitWithQuantity(planUnitMap.license)}
    //     </div>
    //   );
    // },
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, this.mx_price(plan))}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                {this.mx_new_license(plan, plan.cartInfo.selected_number)}
                {this.mx_edit(plan)}
                {this.showRemove && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
